import { useEffect, useRef, useState } from "react";
import { getCommodityOwner } from "../../../../http/api/CommodityOwnerAPI";
import { getProduct } from "../../../../http/api/ProductAPI";
import { getDirectorEmployee } from "../../../../http/api/MasterAPI";
import { validateIntegerOrEmpty } from "../../../../utils/validation";

/**
 * 販売原票一括入力　検索条件管理hook
 */
export const useEntrySearchBox = () => {
  const [searchCondition, setSearchCondition] = useState({
    commodityOwner: null,
    product: null,
    directorEmployee: null,
    arrivalDate: '',
    deliveryDate: '',
    salesRecordStatus: 0,
    qrPrintStatus: 0,
    salesRecordNo: null
  });

  const prevSearchConditionRef = useRef({...searchCondition});

  const [commodityOwners, setCommodityOwners] = useState([]);
  const [products, setProducts] = useState([]);
  const [directorEmployees, setDirectorEmployees] = useState([]);

  const changeSearchCondition = (propName) => (value) => {
    setSearchCondition((prev) => ({
      ...prev, [propName]: value
    }));
  }

  const resetPrevSearchCondition = () => {
    setSearchCondition(prevSearchConditionRef.current);
  }

  const memorizeCurrentSearchCondition = () => {
    prevSearchConditionRef.current = {...searchCondition};
  }
  
  useEffect (() => {
    (async () => {
      const commodityOwnerRes = await getCommodityOwner({isSupplier: true});
      setCommodityOwners(commodityOwnerRes.listCommodityOwnerInfo);

      const productRes = await getProduct({});
      setProducts(productRes.listProductInfo);

      const directorEmployeeRes = await getDirectorEmployee({});
      setDirectorEmployees(
        directorEmployeeRes.masterVarInfo.map((varInfo) => ({
          directorEmployeeId: varInfo.varCd,
          directorEmployeeName: varInfo.varValue1
        })
      ));
    })();
  }, []);

  const enabledSearch = (
      searchCondition.commodityOwner != null
        && searchCondition.deliveryDate != ''
        && validateIntegerOrEmpty(searchCondition.salesRecordNo || '')
    )

  return { 
    searchCondition,
    prevSearchCondition : prevSearchConditionRef.current,
    changeSearchCondition,
    commodityOwners,
    products,
    directorEmployees,
    resetPrevSearchCondition,
    memorizeCurrentSearchCondition,
    enabledSearch
  };  
}


